module.exports = __webpack_public_path__ + "img/house-icon.d53f269.png";